/* eslint-disable @1js/office-online-rules/no-v8-imports-for-fluentui */
import type { IButtonProps } from "@fluentui/react";

export function getLabelButtonProps(
  label: string,
  hideLabel: boolean | undefined
): Partial<IButtonProps> {
  if (hideLabel) {
    // VSO: 1800402 - Replace with tooltip component
    return {
      title: label,
    };
  }
  return {
    text: label,
  };
}
